import type { ViewerLocale } from "@garimpa/lib/viewerPreferences";

import type { Messages } from "./messages";

const messagesByLocale = new Map<ViewerLocale, Messages>();

export function readRouteMessages(locale: ViewerLocale): Messages | undefined {
  return messagesByLocale.get(locale);
}

export function rememberHydratedMessages(locale: ViewerLocale, messages: Messages): void {
  messagesByLocale.set(locale, messages);
}
